import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFolder from '../Shared/ChunkedUploadFolder';
import './NewAdministrationUploadFolder.css';

const NEW_ADMINISTRATION_ROOT =
  process.env.REACT_APP_ADMIN_START_PATH || '/new-administration';

function NewAdministrationUploadFolder({
  currentPath,
  userId,
  onFolderUploaded,
}) {
  return (
    <ChunkedUploadFolder
      currentPath={currentPath}
      userId={userId}
      onFolderUploaded={onFolderUploaded}
      rootPath={NEW_ADMINISTRATION_ROOT}
      sessionPrefix="new_administration_folder"
    />
  );
}

NewAdministrationUploadFolder.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFolderUploaded: PropTypes.func,
};

export default NewAdministrationUploadFolder;
